import MyMoneyModal from "../../components/modal/MyRegisterModal";
import { useSelector, useDispatch } from "react-redux";
import { createAccount, updateAccount } from "../../actions/account";
import { useNavigate } from "react-router-dom";
import React from "react";
import ReactDOM from "react-dom";
import {
  PACKAGE_DAILY,
  SHOW_MSISDN,
  SHOW_OTP,
  SHOW_SUCCESS,
} from "../../common/constant";
import { restApi, restPostApi } from "../../services/httpService";
import {
  loginByUniIdUrl,
  registerByOtpConfirmUrl,
  registerByOtpConfirmUrlloginUrl,
  registerByOtpUrl,
  uniIdLoginUrl,
  uniCheckStateUrl,
  updateUserStateUrl,
} from "../../common/url";
import { httpSuccess, success, waitingForOtp } from "../../common/errorCode";
import { isNotNull } from "../../common/utils";
import MyResultModal from "../../components/modal/MyResultModal";
import { useTranslation } from "react-i18next";
import { loginSession } from "../../actions/session";

const LoginFromUniID = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const urlParams = new URLSearchParams(window.location.search);
  let code = urlParams.get("authorization_code");

  console.log("fromUniID code: " + code);
  async function getUserInfo() {
    // get user info
    let res = await restPostApi(loginByUniIdUrl, {
      code: code,
    });
    console.log("status: " + res.status);

    if (res.status === httpSuccess) {
      console.log("errorCode: " + res.data.errorCode);
      if (res.data.errorCode === success) {
        // create account
        // dispatch(createAccount(res.data.data));

        // create account
        let accountInfo = {
          accountUser: res.data.data.accountUser,
          regInfos: res.data.data.regInfos,
        };
        dispatch(createAccount(accountInfo));

        let tokenInfo = {
          token: res.data.data.token,
          refreshToken: res.data.data.refreshToken,
        };
        dispatch(loginSession(tokenInfo));

        // // check service from Uniservice
        // let resCheckUniservice = await restPostApi(
        //   uniCheckStateUrl,
        //   {
        //     access_token: res.data.data.laoIdToken,
        //     client_id: "504852ed-0bbc-4972-a392-dc64f5d3600c",
        //     sp_code: "704240500001",
        //     sub_service_code: 70424050000101,
        //   },
        //   {
        //     token:
        //       "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vdW5pc2VydmljZS5sYW9zYXBwLmxhL2FkbWluL3Byb2ZpbGUiLCJpYXQiOjE3MTkyMTQ2NzYsIm5iZiI6MTcxOTIxNDY3NiwianRpIjoiNXlPdHJNMGNselJrR3FpVyIsInN1YiI6IjgzIiwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyJ9.4rceTMuH0V7pM149IveN-i89a2uoESZFuSG3c27gHko",
        //   }
        // );
        // if (resCheckUniservice.success === true) {
        //   // update to api
        //   await restPostApi(updateUserStateUrl, {
        //     state: res.data.subServices[0].allow,
        //   });
        // }

        navigate("/home", { replace: true });
      } else {
        console.log("message: " + res.data.message);
        // setErrorMessage(res.data.message)
        navigate("/login", { replace: true });
      }
    } else {
      console.log("message: " + res.data.message);
      // setErrorMessage(res.data.message)
      navigate("/login", { replace: true });
    }
  }

  React.useEffect(() => {
    getUserInfo();
  });

  return <div></div>;
};

export default LoginFromUniID;
